import { CancelButton } from '@core/components/Buttons';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { Grid, Typography } from '@material-ui/core';
import React from 'react';

const funcionalidades = {
  PARAMETROS_BOLETO_PIX: { descricao: 'Parâmetros de Boleto', path: 'Configurações > Parâmetros > Boleto' },
  PARAMETROS_PARTNER_BANK: {
    descricao: 'Parâmetros do Partner Bank',
    path: 'Configurações > Parâmetros > Partner Bank',
  },
  PARAMETROS_CONTA_BANCARIA: {
    descricao: 'Parâmetros de conta bancária',
    path: 'Configurações > Parâmetros > Conta bancária',
  },
  INFORMACOES_EMPRESA: { descricao: 'Informações da empresa', path: 'Nome do usuário no cabeçalho > Minha empresa' },
  INFORMACOES_CLIENTE: { descricao: 'Informações do cliente', path: 'Vendas e serviços > Clientes' },
  INFORMACOES_FORNECEDOR: { descricao: 'Informações do fornecedor', path: 'Suprimetos > Fornecedores' },
  INFORMACOES_DESTINATARIO:{descricao: 'Informações do cliente', path: 'Vendas e serviços > Clientes'}
};

const campos = {
  MODELO_COBRANCA: 'Modelo da cobrança',
  TIPO_COBRANCA: 'Tipo da cobrança',
  CONTA_BANCARIA: 'Conta bancária',
  AGENCIA: 'Agência',
  CONTA: 'Conta',
  CARTEIRA: 'Carteira',
  CNAB: 'CNAB',
  NUMERO_CONVENIO: 'Número do convênio',
  NOSSO_NUMERO: 'Nosso número',
  SEQUENCIAL_REMESSA: 'Sequencial de remessa inicial',
  CHAVE_PIX: 'Chave Pix da conta principal',
  CPF_CNPJ: 'CPF/CNPJ',
  NOME_RAZAO_SOCIAL: 'Nome/Razão social',
  ENDERECO: 'Endereço',
};

const Content = ({ pendencias }) => {
  return (
    <>
      <Grid container spacin={3}>
        <Grid item xs={12} className="mb-16">
          <Typography style={{ fontWeight: 'bold' }}>
            Para gerar cobrança, é necessário que as informações abaixo estejam devidamente preenchidas:
          </Typography>
        </Grid>
        {pendencias?.map((item, i) => (
          <Grid item xs={12} className="mb-16">
            <Typography>
              {i + 1} - {funcionalidades[item.funcionalidade].descricao} devem estar cadastrados:
            </Typography>
            <div className="mt-16 mb-16">
              {item?.campos.map((campo) => (
                <Grid item xs={12}>
                  <Typography>{campos[campo]}</Typography>
                </Grid>
              ))}
            </div>
            <Typography>Acesse: {funcionalidades[item.funcionalidade].path}</Typography>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

const PendenciasModal = ({ show, pendencias, onClose }) => {
  return (
    <SimpleDialog open={show} onClose={onClose}>
      <SimpleDialogContent
        header={{
          title: 'Pendências para gerar cobrança',
          toolbar: (
            <>
              <CancelButton onClick={onClose}>Fechar</CancelButton>
            </>
          ),
        }}
        content={<Content pendencias={pendencias} />}
      />
    </SimpleDialog>
  );
};

export default PendenciasModal;
